export const costItem: any = {
  serviceType_flight: "Flight",
  serviceType_hotel: "Hotel",
  serviceType_optional_tour: "Optional Tour",
  serviceType_railway: "Railway",
  totalPrice: "Price",
  totalFee: "Handling Fee",
};
